var cookieNotice = {
    render: function(){
        var cookie_popup_container = $('#popup'),
            cookie_popup_close = cookie_popup_container.find('.popup__close'),
            cookie_popup_mini_container = $('.popup__mini'),
            cookie_popup_mini_text = cookie_popup_mini_container.find('.popup__mini-text'),
            cookie_popup_mini_close = cookie_popup_mini_container.find('.popup__mini-close'),
            cookie_cname = 'disable_popup';

        function setCookie(){
            localStorage.setItem("disable_popup", "true");
        }

        function getCookie(){
            return localStorage.getItem("disable_popup");
        }

        // Check if cookie is set to display popup
        if (getCookie() != 'true'){
            setTimeout(function() {
                openPopupContainer();
            }, 2000);
        }

        function openPopupMiniContainer(){
            cookie_popup_mini_container.fadeIn();
        }

        function closePopupMiniContainer(){
            cookie_popup_mini_container.fadeOut();
        }

        function openPopupContainer(){
            cookie_popup_container.fadeIn();

            cookie_popup_container.click(function() {
                // clicked outside element
                closePopupContainer();
                
                setTimeout(function() {
                    openPopupMiniContainer();
                }, 1000);
            });

            cookie_popup_container.find('.popup__inner').click(function(event) {
                // clicked inside element
                event.stopPropagation();
            });
        }

        function closePopupContainer(){
            cookie_popup_container.fadeOut();
        }

        cookie_popup_close.on('click', function(){
            closePopupContainer();
            
            setTimeout(function() {
                openPopupMiniContainer();
            }, 1000);
        });

        cookie_popup_mini_text.on('click', function(){
            closePopupMiniContainer();
            openPopupContainer();
        });

        cookie_popup_mini_close.on('click', function(){
            closePopupMiniContainer();
            setCookie();
        });
    },
    init: function(){
        this.render();
    }
};

cookieNotice.init();
